export enum Layout {
  TARGET_AND_TEXT = 'TargetAndText',
  TARGET_AND_GRAPH = 'TargetAndGraph',
  GRAPH_AND_BAROMETER = 'GraphAndBarometer',
}
